import axios from './axiosInterceptors';
import authHeader from "./authentification-header";

const API_URL = "/api/v1/transactions/";

const getTransactionsByTicketsIds = (ticketsIds) => {
    return axios.post(API_URL + 'by-tickets', ticketsIds, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};
const searchTransactions = (formData) => {
    return axios.post(API_URL + 'search', formData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
            if (err.response.status === 500) {
                //redirect to login
            }
        })
};
const changeStatusByTicketsId = (formData) => {
    return axios.post(API_URL + 'change-status', formData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};
const changeStatusByTicketId = (formData) => {
    return axios.post(API_URL + 'change-status-ticket', formData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};
const getTransactionWithDoItems = (ticketId) => {
    return axios.get(API_URL + 'with-do-items?ticketid=' + ticketId, { headers: authHeader() })
};
const editTransaction = (formData) => {
    return axios.post(API_URL + 'edit', formData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};
const deleteTransaction = (ticketId) => {
    return axios
        .delete(API_URL + "delete",
            { data: { ticketId: ticketId } }).then((response) => {
                return response.data;
            });
};

const allActions = {
    getTransactionsByTicketsIds,
    getTransactionWithDoItems,
    searchTransactions,
    editTransaction,
    deleteTransaction,
    changeStatusByTicketsId,
    changeStatusByTicketId,
};

export default allActions;